import IssueService from '@/services/issue.service';
import ExtraFieldService from '@/services/extrafield.service';
import StatusService from '@/services/status.service';
const state = {
    status: [],
    issues: [],
    inpagination: false,
    loading: false
};
/* eslint-disable no-shadow */
const mutations = {
    addIssue: (state, issue) => {
        if (state.inpagination) {
            if (state.issues.content.some(v => v.id === issue.id)) {
                return;
            }
            state.issues.content.push(issue);
        } else {
            if (state.issues.some(v => v.id === issue.id)) {
                return;
            }
            state.issues.push(issue);
        }
    },

    updateIssue: (state, issue) => {
        if (state.inpagination) {
            for (let v of state.issues.content) {
                if (v.id === issue.id) {
                    v = Object.assign(v, issue);
                    break;
                }
            }
        } else {
            for (let v of state.issues) {
                if (v.id === issue.id) {
                    v = Object.assign(v, issue);
                    break;
                }
            }
        }
    },

    getIssues: (state, issues) => {
        state.issues = issues;
    },

    getIssueField: (state, extraFields) => {
        state.issueFields = extraFields;
    },

    getStatus: (state, status) => {
        state.status = status;
    },

    inPagination: (state, setBool) => {
        state.inpagination = setBool;
    },

    setLoading: (state, loading) => {
        state.loading = loading;
    }
};

const actions = {
    addIssue({ commit }, issue) {
        commit('addIssue', issue);
    },
    updateIssue({ commit }, issue) {
        commit('updateIssue', issue);
    },
    setPaginated({ commit }, bool) {
        commit('inPagination', bool);
    },
    getStatus({ commit }) {
        commit('setLoading', true);
        return StatusService.getStatus(true)
            .then(
                response => {
                    commit('getStatus', response.data);
                    commit('setLoading', false);
                },
                error => {
                    console.log(error.response && error.response.data ||
                        error.message || error.toString());
                }
            );

    },
    getIssueFields({ commit }) {
        commit('setLoading', true);
        return ExtraFieldService.getExtraFields(true)
            .then(
                response => {
                    commit('getIssueField', response.data);
                    commit('setLoading', false);
                },
                error => {
                    console.log(error.response && error.response.data ||
                        error.message || error.toString());
                }
            );

    },
    getIssues({ commit }) {
        commit('setLoading', true);
        return IssueService.getAllIssues()
            .then(
                response => {
                    commit('getIssues', response.data);
                    commit('inPagination', false);
                    commit('setLoading', false);
                },
                error => {
                    console.log(error.response && error.response.data ||
                        error.message || error.toString());
                }
            );

    },
    getPaginatedIssues({ commit }, data) {
        var queryString;
        commit('setLoading', true);
        data.page -= 1;
        queryString = Object.keys(data).map(key => key + '=' + data[key]).join('&');

        return IssueService.getPaginatedIssues(queryString)
            .then(
                response => {
                    commit('getIssues', response.data);
                    commit('inPagination', true);
                    commit('setLoading', false);
                },
                error => {
                    console.log(error.response && error.response.data ||
                        error.message || error.toString());
                }
            );
    },
    getActiveIssues({ commit }) {
        commit('setLoading', true);
        return IssueService.getActiveIssues()
            .then(
                response => {
                    commit('getIssues', response.data);
                    commit('inPagination', false);
                    commit('setLoading', false);
                },
                error => {
                    console.log(error.response && error.response.data ||
                        error.message || error.toString());
                }
            );

    },
    getPerformantIssues({ commit }) {
        commit('setLoading', true);
        return IssueService.getPerformantIssues()
            .then(
                response => {
                    commit('getIssues', response.data);
                    commit('inPagination', false);
                    commit('setLoading', false);
                },
                error => {
                    console.log(error.response && error.response.data ||
                        error.message || error.toString());
                }
            );

    },
    getMyIssues({ commit }, userid) {
        commit('setLoading', true);
        return IssueService.getMyTickets(userid)
            .then(
                response => {
                    commit('getIssues', response.data);
                    commit('inPagination', false);
                    commit('setLoading', false);
                },
                error => {
                    console.log(error.response && error.response.data ||
                        error.message || error.toString());
                }
            );
    },
    getCustomerIssues({ commit }, email) {
        commit('setLoading', true);
        return IssueService.getMyTicketCustomer(email)
            .then(
                response => {
                    let retVal = response.data;
                    const fromDate = new Date().setMonth(new Date().getMonth() - 3);

                    retVal = retVal.filter(ticket => {
                        return new Date(ticket.dateCreated.split('T')[0]).getTime() >= fromDate;
                    });

                    commit('getIssues', retVal);
                    commit('inPagination', false);
                    commit('setLoading', false);
                },
                error => {
                    console.log(error.response && error.response.data ||
                        error.message || error.toString());
                }
            );
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
/* eslint-enable no-shadow */
